import { $exists as __exists, createQueryOperator } from "../../_predicates";
const $exists = createQueryOperator(__exists);
export {
  $exists
};
